import React, { Fragment } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import Modal from 'CommonComponents/Modal';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';
import TextFormField from 'CommonComponents/TextFormField';

const SaveConfigScheme = Yup.object().shape({
    name: Yup.string().required($t('This value is required')),
});

/**
 * Small name-entry modal for saving the current Actuals-vs-Budget config screen
 * as a reusable "Saved configuration" (IB-834) — a single required name field.
 */
export default function SaveConfigModal({ modal, onSave, saving }) {
    const close = () => {
        modal.hide();
    };

    return (
        <Modal id="save-avb-config-modal" modal={modal}>
            <ModalHeader close={close}>{$t('Save configuration')}</ModalHeader>
            <Formik
                enableReinitialize
                initialValues={{ name: '' }}
                validationSchema={SaveConfigScheme}
                onSubmit={(values, actions) => {
                    Promise.resolve(onSave(values.name.trim())).finally(() => {
                        actions.setSubmitting(false);
                    });
                }}
            >
                {({ isSubmitting, handleSubmit }) => (
                    <Fragment>
                        <div className="tw-rounded-b tw-mb-6 tw-space-y-3">
                            <div>
                                <TextFormField
                                    label={$t('Configuration name')}
                                    required={true}
                                    type="text"
                                    name="name"
                                    disabled={isSubmitting || saving}
                                    horizontalLayout={true}
                                ></TextFormField>
                            </div>
                        </div>
                        <ModalFooter
                            submitButtonVariant="primary"
                            cancelButtonText={$t('Cancel')}
                            primaryButtonText={$t('Save configuration')}
                            onCancel={close}
                            handleSubmit={() => handleSubmit()}
                        ></ModalFooter>
                    </Fragment>
                )}
            </Formik>
        </Modal>
    );
}
